import { useEffect, useRef, useState } from 'react';
import { parseUnits, Interface } from 'ethers';
import { getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import { mintImpactCertificate, getProjectIcPreview } from '../../apis/projects/projects';
import { getAllCertificates } from '../../apis/impactCertificates/impactCertificates';
import { useContext } from 'react';
import { ProfileContext } from '../../contexts/ProfileContext';
import ModalBox from '../../ui/ModalBox';
import Overlay from '../../ui/Overlay';
import Button from '../../ui/Button';
import Dropdown from '../../ui/Dropdown';
import ModalPreview from '../../ui/ModalPreview';
import axios from 'axios';
import { BASE_URL, IC_FEE_RECIEVERADDRESS } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
import { useForm, useController } from 'react-hook-form';
import { metaConnectionProjectIc } from '../../helpers/greenPillHelper';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { BrowserProvider, formatEther } from 'ethers';
import { getTokenBalance } from '../../apis/geenpills/mintNFT';
import ButtonNew from '../../ui/ButtonNew';


const chainOptions = [
    // {
    //     name: 'optimism sepolia',
    //     image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
    //     chainId: 11155420,
    //     id: '67b721d9e0d44278224d2a55',
    //     _id: '67b721d9e0d44278224d2a55',
    //     symbol: 'optimism sepolia',
    // },
    // arbitrum 42161, base 8453,  celo 42220, optimism 10
    {
        name: 'optimism',
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
        chainId: 10,
        symbol: 'optimism',
    },
    {
        name: 'arbitrum',
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1738068284318.png',
        chainId: 42161,
        symbol: 'arbitrum',
    },
    {
        name: 'celo',
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',
        chainId: 42220,
        symbol: 'celo',
    },
    {
        name: 'base',
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054515393.jpg',
        chainId: 8453,
        symbol: 'base',
    },
];
// 0x7a515022eC0a175dB9600E6E11461e031eaF8c95
const tokenOptions = [
    //  {
    //   address: '0x7a515022eC0a175dB9600E6E11461e031eaF8c95',
    //   symbol: 'TEST',
    //   decimals: 6,
    //   image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616284068.png',
    //   chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1738068284318.png',
    //   chainName: 'optimism sepolia',
    // },
    {
      address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
      symbol: 'USDC',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616284068.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1738068284318.png',
      chainName: 'arbitrum',
    },
    {
      address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      symbol: 'USDT',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743615589038.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1738068284318.png',
      chainName: 'arbitrum',
    },
    {
      address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
      symbol: 'DAI',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743617033678.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1738068284318.png',
      chainName: 'arbitrum',
    },
    {
      address: '0x4F604735c1cF31399C6E711D5962b2B3E0225AD3',
      symbol: 'USDGLO',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1722922601208.jpg',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1738068284318.png',
      chainName: 'arbitrum',
    },
    {
      address: '0xE4fE50cdD716522A56204352f00AA110F731932d',
      symbol: 'DAI',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743617033678.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',
      chainName: 'celo',
    },
    {
      address: '0xcebA9300f2b948710d2653dD7B07f33A8B32118C',
      symbol: 'USDC',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616284068.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',
      chainName: 'celo',
    },
    {
      address: '0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e',
      symbol: 'USDT',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743615589038.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',
      chainName: 'celo',
    },
    {
      address: '0x765DE816845861e75A25fCA122bb6898B8B1282a',
      symbol: 'cUSD',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744717591451.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',
      chainName: 'celo',
    },
    {
      address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
      symbol: 'USDC',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616284068.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054515393.jpg',
      chainName: 'base',
    },
    {
      address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
      symbol: 'DAI',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743617033678.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054515393.jpg',
      chainName: 'base',
    },
    {
      address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
      symbol: 'USDT',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743615589038.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054515393.jpg',
      chainName: 'base',
    },
    {
      address: '0x4F604735c1cF31399C6E711D5962b2B3E0225AD3',
      symbol: 'USDGLO',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1722922601208.jpg',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054515393.jpg',
      chainName: 'base',
    },
    {
      address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
      symbol: 'USDT',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743615589038.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
      chainName: 'optimism',
    },
    {
      address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
      symbol: 'DAI',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743617033678.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
      chainName: 'optimism',
    },
    {
      address: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
      symbol: 'USDC',
      decimals: 6,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616284068.png',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
      chainName: 'optimism',
    },
    {
      address: '0x4F604735c1cF31399C6E711D5962b2B3E0225AD3',
      symbol: 'USDGLO',
      decimals: 18,
      image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1722922601208.jpg',
      chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
      chainName: 'optimism',
    },
    // {
    //   address: '0x7a515022eC0a175dB9600E6E11461e031eaF8c95',
    //   symbol: 'TEST',
    //   decimals: 0,
    //   image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743615589038.png',
    //   chainImage: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1740054968965.png',
    //   chainName: 'optimism sepolia',
    // },
  ];
  
  

// Props "close" is injected by Modal.Window
function ProjectICModal({ close, projectStartDate, projectTitle = '', projectDescription = '', projectId = '', onMintSuccess = () => {} }) {
    const profileCtx = useContext(ProfileContext);
    const navigate = useNavigate()
    const dispatch = profileCtx?.dispatch;
    const [loading, setLoading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState('');
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const { register, handleSubmit, formState: { errors }, watch, control, setValue } = useForm({
        mode: 'onChange',
        defaultValues: {
            estimatedEndDate: '',
            projectDescription: projectDescription || '',
            chain: null,
            token: null,
        },
    });


    const { field: chainField } = useController({
        name: 'chain',
        control,
        rules: {
            validate: (value) => {
                if (!value) return 'Please choose a chain';
                return true;
            },
        },
    });

    const { field: tokenField } = useController({
        name: 'token',
        control,
        rules: {
            validate: (value) => {
                if (!chainField.value) return 'Please choose a token';
                if (!value) return 'Please choose a token';
                return true;
            },
        },
    });

    const { field: estimatedEndDateField } = useController({
        name: 'estimatedEndDate',
        control,
        rules: {
            required: 'Please select an end date',
            validate: (value) => {
                if (!value) return 'Please select an end date';
                
                if (projectStartDate) {
                    const selectedDate = new Date(value);
                    const startDate = new Date(projectStartDate);
                    
                    // Reset time to compare only dates
                    selectedDate.setHours(0, 0, 0, 0);
                    startDate.setHours(0, 0, 0, 0);
                    
                    if (selectedDate < startDate) {
                        const formattedStartDate = startDate.toLocaleDateString('en-US', { 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                        });
                        return `Estimated end date  cannot be earlier than the project start date (${formattedStartDate})`;
                    }
                }
                
                return true;
            }
        },
    });

    const myRef = useRef({ close });

    useEffect(
        function () {
            function handleClick(e) {
                // Don't close if preview modal is open
                if (showPreviewModal) return;
                
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close, showPreviewModal]
    );

    
        const getConfig = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

    const transferToken = async ({
        tokenAddress, // selected token from the dropdown
        recieverAddress, // hard code this address "0xD4BBFf164A2178701c5E2d7A08B8675628C86Fea",
        amount, // 20
        decimals,
        chainId,
    }) => {
        const metaMaskProvider = getMetaMaskProvider();
        let transactionHash;

        try {
            const transferAmount = parseUnits(amount.toString(), decimals); // Adjust decimals if needed (e.g., 6 for USDC)

            // const accounts = await metaMaskProvider.request({ method: 'eth_requestAccounts' });
            // const from = accounts[0];
            const from = await metaConnectionProjectIc(undefined,chainId)
            const transferData = new Interface([
                'function transfer(address to, uint256 value) public returns (bool)',
            ]).encodeFunctionData('transfer', [recieverAddress, transferAmount]);

            const transactionParams = {
                to: tokenAddress, // ERC-20 contract address
                from: from, // Fetch connected account
                data: transferData, // Encoded function call
                value: '0x0', // No ETH transfer
            };

            // Send transaction
            const result = await metaMaskProvider.request({
                method: 'eth_sendTransaction',
                params: [transactionParams],
            });
            transactionHash = result;
        } catch (error) {
            console.error('Error during transfer:', error);
            return { success: false, code: error?.message };
        }

        return { success: true, transactionHash }; // check by "success" if value of success is true then call the api to mint the project ic
    };

    const handlePreview = async () => {
        const formData = watch();
        
        // Validate required fields for preview
        if (!formData.estimatedEndDate || !formData.projectDescription || !chainField.value) {
            toast.error('Please fill in all required fields to see the preview');
            return;
        }

        try {
            setPreviewLoading(true);
            const response = await getProjectIcPreview(
                projectId,
                formData.estimatedEndDate,
                formData.projectDescription,
                chainField.value.name
            );
            
            if (response?.previewImage) {
                setPreviewImageUrl(response.previewImage);
                setShowPreviewModal(true);
            } else {
                toast.error('Failed to generate preview image');
            }
        } catch (error) {
            const msg = error?.response?.data?.message || 'Failed to generate preview';
            toast.error(msg);
        } finally {
            setPreviewLoading(false);
        }
    };
console.log(IC_FEE_RECIEVERADDRESS,"this is reciever",projectStartDate)
    const handleGenerate = async (data) => { 
       
    
        try {
            setLoading(true);
            const accessToken = await getAccessToken();
            const url = `${BASE_URL}/project/impactCertificateMintability?projectId=${projectId}`;
                        const response = await axios.get(url, getConfig(accessToken));

            if (response.status === 200 && response.data?.impactCertificateMintable) {
                if (!projectId) {
                    toast.error('Project ID is missing.');
                    return;
                }

                if (!chainField.value || !tokenField.value) {
                    toast.error('Please select chain and token.');
                    return;
                }

                // Connect to MetaMask and switch chain if needed
                const metaMaskProvider = getMetaMaskProvider();
                const accounts = await metaMaskProvider.request({ method: 'eth_requestAccounts' });
                const metaConnectionResponse = await metaConnectionProjectIc(accounts[0], chainField.value.chainId);
                
                // Check if chain connection failed
                if (metaConnectionResponse === 'chainerror') {
                    setLoading(false);
                    return;
                }

                // 1. Check gas fee first (native token balance)
                const provider = new BrowserProvider(metaMaskProvider);
                const signer = await provider.getSigner();
                const address = await signer.getAddress();
                const balance = await provider.getBalance(address);
                const balanceEth = parseFloat(formatEther(balance));

                // Estimate minimum gas fee needed (0.001 ETH/native token as buffer)
                const minGasRequired = 0.001;
                
                // if (balanceEth < minGasRequired) {
                //     const nativeTokenSymbol = chainField.value.chainId === 42220 ? 'CELO' : 
                //                              chainField.value.chainId === 42161 ? 'ETH' :
                //                              chainField.value.chainId === 8453 ? 'ETH' :
                //                              chainField.value.chainId === 10 ? 'ETH' : 'ETH';
                //     toast.error(
                //         `Insufficient ${nativeTokenSymbol} for gas fees: You need at least ${minGasRequired} ${nativeTokenSymbol}`
                //     );
                //     setLoading(false);
                //     return;
                // }
                
                // 2. Check token balance
                const requiredAmount = 1; // $10 worth of tokens
                const tokenBalance = await getTokenBalance(
                    chainField.value.chainId, 
                    tokenField.value.address, 
                    metaConnectionResponse
                );

                const requiredTokenAmount = requiredAmount * (10 ** tokenField.value.decimals);
                
                if (tokenBalance < requiredTokenAmount) {
                    toast.error(
                        `Insufficient ${tokenField.value.symbol}: You need ${requiredAmount} ${tokenField.value.symbol}`
                    );
                    setLoading(false);
                    return;
                }

                const transferResponse = await transferToken({
                    tokenAddress: tokenField.value.address,
                    recieverAddress: IC_FEE_RECIEVERADDRESS,
                    amount: 1,
                    decimals: tokenField.value.decimals,
                    chainId: chainField.value.chainId,
                });
console.log(transferResponse,"what was the response here ")
                if (transferResponse.success) {
                    const payload = {
                        projectId,
                        paymentBlockchain: chainField.value.name,
                        paymentTokenAddress: tokenField.value.address,
                        paymentTransactionHash: transferResponse.transactionHash,
                        estimatedEndDate: data.estimatedEndDate,
                        projectDescription: data.projectDescription,
                        mintBlockchain: chainField.value.name,
                        receiverAddress: accounts[0],
                    };

                    const mintResponse = await mintImpactCertificate(payload);
                    console.log(mintResponse,"see the mint response")
                    if (mintResponse) {
                        try {
                            const freshCertificates = await getAllCertificates();
                            dispatch && dispatch({ type: 'ic/setImpactcertificates', payload: freshCertificates });
                            // toast.success(`Project Impact Certificate for ‘Project ${projectTitle}’ has been created! Minting is in progress, please wait for 2-3 minutes before refreshing the page ‘Hall of Impact’`);
                            navigate(`/profile/gallery?s=${projectTitle}`)
                        } catch (e) {
                            console.error('Failed to refresh certificates', e);
                        }
                        finally{
                            onMintSuccess(mintResponse);
                            close()
                        }
                    }
                } else {
                    toast.error(transferResponse.code || 'Token transfer failed.');
                }
            } else {
                toast.error(response.data?.message || 'Impact Certificate cannot be minted for this project.');
            }
        } catch (error) {
            const msg = error?.response?.data?.message || 'Something went wrong while checking mintability.';
            toast.error(msg);
        } finally {
            setLoading(false);
        }
            
    };

    // derive tokens based on selected chain
    const filteredTokens = chainField.value
        ? tokenOptions.filter((t) => t.chainName?.toLowerCase() === chainField.value.name?.toLowerCase())
        : [];

    return (
        <>
        <style>
            {`
                .project-ic-datepicker .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
                    display: block !important;
                }
                .react-datepicker__input-container {
                    width: 100% !important;
                }
                    .react-datepicker__input-container input:focus {
    outline: none !important;
 
    box-shadow: none !important;
}
                .react-datepicker__input-container input {
                    width: 100% !important;
                    min-width: 100% !important;
                    max-width: 100% !important;
                }
                .react-datepicker-wrapper {
                    width: 100% !important;
                    display: block !important;
                }
            `}
        </style>
        <Overlay>
     <div
                ref={myRef}
                className="absolute rounded-lg left-[50%] w-[53%]    bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
            >
            <ModalBox
            close={close}
            onSubmit={handleSubmit(handleGenerate)}
            loading={loading}
            width="w-full"
            isConfirmModal={false}
        >
            <div className="flex flex-col gap-4">
                <div>
                    <h2 className="text-[1.75rem] font-medium  text-textPrimary">
                        Impact Certificate for ‘{projectTitle}’
                    </h2>
                    <p className="text-base text-[#8C8C8C] mt-1">
                        Impact certificates are digital proof of your impact that can be traded in the form of NFTs
                    </p>
                </div>

                <hr className="border-borderUnderline" />

                {/* Estimated End Date */}
                <div className="flex flex-col gap-1">
                    <label className="font-semibold text-textPrimary text-base">Estimated End Date <sup className="text-lg relative top-[1px]">*</sup></label>
                    <div className="relative w-full">
                        <DatePicker
                            open={isDatePickerOpen}
                            onInputClick={() => setIsDatePickerOpen(true)}
                            onClickOutside={() => setIsDatePickerOpen(false)}
                            className="border border-borderUnderline w-full shadow-sm text-sm bg-grayBgNormal placeholder:text-textTertiary font-semibold rounded-md px-4 py-2 pl-10 focus:outline-none focus:border-blueNormal focus:ring-0"
                            placeholderText="Set Date"
                            selected={estimatedEndDateField.value ? new Date(estimatedEndDateField.value) : null}
                            onChange={(date) => {
                                if (date) {
                                    // Adjust for timezone to prevent date shifting
                                    const year = date.getFullYear();
                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                    const day = String(date.getDate()).padStart(2, '0');
                                    const formattedDate = `${year}-${month}-${day}`;
                                    estimatedEndDateField.onChange(formattedDate);
                                } else {
                                    estimatedEndDateField.onChange('');
                                }
                                setIsDatePickerOpen(false);
                            }}
                            dateFormat="MMMM d, yyyy"
                            calendarClassName="project-ic-datepicker"
                        />
                        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                                <path d="M4 6V7.33333H2.66667V6H4ZM6.66667 6V7.33333H5.33333V6H6.66667ZM9.33333 6V7.33333H8V6H9.33333ZM10.6667 1.33333C11.0203 1.33333 11.3594 1.47381 11.6095 1.72386C11.8595 1.97391 12 2.31304 12 2.66667V12C12 12.3536 11.8595 12.6928 11.6095 12.9428C11.3594 13.1929 11.0203 13.3333 10.6667 13.3333H1.33333C0.979711 13.3333 0.640573 13.1929 0.390524 12.9428C0.140476 12.6928 0 12.3536 0 12V2.66667C0 2.31304 0.140476 1.97391 0.390524 1.72386C0.640573 1.47381 0.979711 1.33333 1.33333 1.33333H2V0H3.33333V1.33333H8.66667V0H10V1.33333H10.6667ZM10.6667 12V4.66667H1.33333V12H10.6667ZM4 8.66667V10H2.66667V8.66667H4ZM6.66667 8.66667V10H5.33333V8.66667H6.66667ZM9.33333 8.66667V10H8V8.66667H9.33333Z" fill="#8C8C8C"/>
                            </svg>
                        </div>
                    </div>
                    {errors?.estimatedEndDate && (
                        <p className="text-red-500 text-base">{errors.estimatedEndDate.message}</p>
                    )}
                </div>

                {/* Brief Description */}
                <div className="flex flex-col gap-1">
                    <label className="font-semibold text-textPrimary text-base">Brief Description <sup className="text-lg relative top-[1px]">*</sup></label>
                                        <textarea
                        rows="3"
                        maxLength={200}
                        placeholder="Describe the impact of the project"
                        className="w-full resize-none rounded-md border border-borderUnderline text-textPrimary placeholder:text-textTertiary bg-grayBgNormal px-3 py-2 text-sm focus:outline-none focus:border-blueNormal focus:ring-0"
                        {...register('projectDescription', {
                            required: 'Please enter a description',
                            maxLength: { value: 200, message: 'The maximum length is 200 characters' }
                        })}
                    ></textarea>
                    <div className='flex items-center justify-between'>
                    {errors?.projectDescription ? (
                        <p className="text-red-500 text-base">{errors.projectDescription.message}</p>
                    ) : <p></p>}
                    <p className="text-xs  text-textSecondary self-end"> <span className='font-semibold'>character limit:</span>  <span> {watch('projectDescription')?.length || 0}/200</span> </p>
                    </div>
                
                </div>

                
                <div>
                <div className="flex gap-4">
                    <div className="flex-1  relative flex flex-col gap-1">
                        <label className="font-semibold text-textPrimary text-base">Chain to Mint Certificate on <sup className="text-lg relative top-[1px]">*</sup></label>
                        <Dropdown
                            w="w-full"
                            data={chainOptions.map((opt) => opt.name)}
                            selected={chainField.value ? chainField.value.name : ''}
                            onSelected={(value) => {
                                const found = chainOptions.find((opt) => opt.name === value);
                                chainField.onChange(found || null);
                                tokenField.onChange(null);
                            }}
                            modifyLabel={(item) => (
                                <span className="flex items-center gap-2">
                                    <img className="w-5 h-5 rounded-full" src={chainOptions.find((opt) => opt.name === item)?.image} alt="" />
                                    <span className='text-textPrimary'>{item}</span>
                                </span>
                            )}
                            modifySelected={(item) => (
                                <span className="flex items-center gap-2">
                                    <img className="w-5 h-5 rounded-full" src={chainOptions.find((opt) => opt.name === item)?.image} alt="" />
                                    <span>{item}</span>
                                </span>
                            )}
                            noSelectedText="Choose Chain"
                            btnClass='h-10 bg-grayBgNormal'
                        
                        />
                    </div>
                    <div className="flex-1 relative flex flex-col gap-1">
                        <label className="font-semibold text-textPrimary text-base">Token for Payment <sup className="text-lg relative top-[1px]">*</sup></label>
                        <Dropdown
                            w="w-full"
                            disabled={!chainField.value}
                            data={filteredTokens.map((opt) => opt.symbol)}
                            selected={tokenField.value ? tokenField.value.symbol : ''}
                            onSelected={(value) => {
                                const found = filteredTokens.find((opt) => opt.symbol === value);
                                tokenField.onChange(found || null);
                            }}
                            modifyLabel={(item) => (
                                <span className="flex items-center gap-2">
                                    <span className="relative">
                                        <img className="w-5 h-5 rounded-full" src={filteredTokens.find((opt) => opt.symbol === item)?.image} alt="" />
                                        <img className="w-2 h-2 absolute top-0 right-0 rounded-full" src={filteredTokens.find((opt) => opt.symbol === item)?.chainImage} alt="" />
                                    </span>
                                    <span className='text-textPrimary'>{item}</span>
                                </span>
                            )}
                            modifySelected={(item) => (
                                <span className="flex items-center gap-2">
                                    <span className="relative">
                                        <img className="w-5 h-5 rounded-full" src={filteredTokens.find((opt) => opt.symbol === item)?.image} alt="" />
                                        <img className="w-2 h-2 absolute top-0 right-0 rounded-full" src={filteredTokens.find((opt) => opt.symbol === item)?.chainImage} alt="" />
                                    </span>
                                    <span className='text-textPrimary'>{item}</span>
                                </span>
                            )}
                            noSelectedText={chainField.value ? 'Choose Token' : 'Choose Chain first'}
                            btnClass={chainField.value ? 'h-10 bg-grayBgNormal' : 'h-10 bg-grayBgNormal cursor-not-allowed'}
                        
                        />
                    </div>
                </div>
                <div className="flex items-center gap-9 mb-6 ">
                        <p className="text-foundryRed flex-1 ">{errors?.chain?.message && errors?.chain?.message}</p>
                        <p className="text-foundryRed flex-1 ">
                            {errors?.token?.message && errors?.token?.message}
                        </p>
                </div>
                </div>
             
                 

                <p className="text-base text-[#8C8C8C]">
                    Note: A payment worth $1 is required for generating an impact certificate. Other information such
                    as SDGS, number of bounties and bounty types will be generated based on bounties in the project
                </p>

                {/* Preview IC Button */}
                <div className='flex items-center '>
                <button
                    onClick={handlePreview}
                    disabled={previewLoading || !watch('estimatedEndDate') || !watch('projectDescription') || !chainField.value || errors?.estimatedEndDate}
                    className="font-semibold text-[#0085FF] w-fit text-base leading-6 cursor-pointer disabled:text-[#0085ff]/60 disabled:cursor-not-allowed flex items-center gap-2 "
                >
                    {previewLoading ? 'Generating Preview...' : 'Preview Impact Certificate'}
                    <span  className={` ${previewLoading || !watch('estimatedEndDate') || !watch('projectDescription') || !chainField.value || errors?.estimatedEndDate?"bg-[#0085FF]/60":"bg-[#0085FF]"}  rounded-sm p-1 `}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <path d="M3.94123 9.76379V8.70496H2.04065L4.423 6.32261L3.67653 5.57614L1.29418 7.95849V6.0579H0.235352V9.76379H3.94123ZM6.32359 4.42202L8.70594 2.03967V3.94026H9.76476V0.234375H6.05888V1.2932H7.95947L5.57712 3.67555L6.32359 4.42202Z" fill="white"/>
                        </svg>
                    </span>
                </button>

                </div>
            

                <hr className="border-borderUnderline" />
                {/* Total cost */}
                <div className='flex items-center justify-between' >
                    <div>
                        <p className="text-textPrimary ">Total one time cost</p>
                        <p className="text-4xl text-textPrimary font-medium mt-1">$ 1</p>
                    </div>
                    <ButtonNew
                        type="button"
                        fixedMinWidth={true}
                        variant="blue"
                        size="sm"
                        disabled={loading || errors?.estimatedEndDate}
                        onClick={handleSubmit(handleGenerate)}
                    >
                        {loading ? 'Loading...' : 'Generate'}
                    </ButtonNew>
                  
                </div>
                 
              
            </div>
        </ModalBox>
            </div>
        </Overlay>
        
        {/* Preview Modal - Outside of main overlay */}
        <ModalPreview
            isOpen={showPreviewModal}
            onClose={() => setShowPreviewModal(false)}
            imageUrl={previewImageUrl}
            title="Project Impact Certificate Preview"
            width="w-[50rem]"
            isShowFooter={false}
        />
        </>
    );
}

export default ProjectICModal;

